export class MediaItem {

  id: string;
  kind: string;
  name: string;
  questionId: number;
  note: string;
  base64: boolean;
  contentOrPath: string;
  captured: string;
  seconds: number;
  secondsRemaining: number;
  extra: string;

  constructor() {
    this.id = null;
    this.kind = null;
    this.name = null;
    this.questionId = null;
    this.note = null;
    this.base64 = null;
    this.contentOrPath = null;
    this.captured = null;
    this.seconds = null;
    this.secondsRemaining = null;
    this.extra = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/mediaitem.ts